import { RespetoPrincipiosAdapter } from '../adapters/RespetoPrincipios.adapter'

export default class CreateRespetoPrincipiosUseCase {
  #repository

  constructor(repository) {
    this.#repository = repository
  }

  async execute(payload) {
    try {
      const DEFAULT_FRECUENCIA_VALUE = 5

      const reactivosCatalog = await this.#repository.getEvaluationItems()
      payload.reactivos = reactivosCatalog.map((reactivo) => ({
        idReactivo: reactivo.id,
        idFrecuencia: DEFAULT_FRECUENCIA_VALUE,
      }))

      const dto = RespetoPrincipiosAdapter.toDto(payload)
      const { data } = await this.#repository.create(dto)

      return data[0].ID
    } catch (error) {
      throw new Error(`Failed to execute CreateRespetoPrincipiosUseCase: ${error.message}`)
    }
  }
}
